export default __webpack_public_path__ + "static/media/intro-button-start.6f532092.png";